export class ListRestoreAccountsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accounts",
            "baseName": "accounts",
            "type": "Array<RestoreAccount>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreAccountsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
